import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import etoLogo from "@/assets/eto-logo.png";

const Impressum = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-light text-foreground">
                Impressum
              </h1>
              <div className="w-24 h-1 bg-primary"></div>
            </div>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">Firmenname</h2>
              <p className="text-muted-foreground">
                Scholz & Scholz Recruitment U.G. (Haftungsbeschränkt)
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">Eingetragen bei</h2>
              <p className="text-muted-foreground">
                Amtsgericht Tostedt<br />
                Handelsregisternummer: HRB 210721
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">Adresse</h2>
              <address className="text-muted-foreground not-italic">
                Scholz & Scholz Recruitment U.G. (Haftungsbeschränkt)<br />
                Römerstraße 6<br />
                21680 Stade
              </address>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">Kontakt</h2>
              <p className="text-muted-foreground">
                Telefon: <a href="tel:+494141426310" className="hover:text-primary transition-colors">+49 (0) 41 41 426 310</a><br />
                E-Mail: <a href="mailto:info@scholz-interim.de" className="hover:text-primary transition-colors">info@scholz-interim.de</a>
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">Rechtlicher Hinweis</h2>
              <div className="space-y-4 text-muted-foreground">
                <p>
                  Im Hinblick auf die technischen Eigenschaften des Internet kann keine Gewähr für die Authentizität, Richtigkeit und Vollständigkeit der im Internet zur Verfügung gestellten Informationen übernommen werden. Es wird auch keine Gewähr für die Verfügbarkeit oder den Betrieb der gegenständlichen Webseite und ihrer Inhalte übernommen.
                </p>
                <p>
                  Jede Haftung für unmittelbare, mittelbare oder sonstige Schääden, unabhängig von deren Ursachen, die aus der Benutzung oder Nichtverfügbarkeit der Daten und Informationen dieser Homepage erwachsen, wird, soweit rechtlich zulässig, ausgeschlossen.
                </p>
                <p>
                  Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                </p>
                <p>
                  Der Inhalt dieser Webseite ist urheberrechtlich geschützt. Verlinkungen auf unsere Webseite sind herzlich willkommen!
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">Cookies</h2>
              <div className="space-y-4 text-muted-foreground">
                <p>
                  Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.
                </p>
                <p>
                  Die meisten der von uns verwendeten Cookies sind so genannte „Session-Cookies". Sie werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Diese Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.
                </p>
                <p>
                  Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">Google Analytics</h2>
              <div className="space-y-4 text-muted-foreground">
                <p>
                  Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc., um eine Analyse der Benutzung der Website zu ermöglichen. Die durch den Einsatz von Google Analytics erzeugten Informationen über Ihre Nutzung diese Website (einschließlich Ihrer IP-Adresse) werden an einen Server der Google Inc. in den USA übertragen und dort gespeichert. Google wird diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten für die Websitebetreiber zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen zu erbringen. Google wird in keinem Fall Ihre IP-Adresse mit anderen Daten von Google in Verbindung bringen. Durch die Nutzung dieser Website erklären Sie sich mit der Bearbeitung der über Sie erhobenen Daten durch Google in der zuvor beschriebenen Art und Weise und zu dem zuvor benannten Zweck einverstanden.
                </p>
                <p>
                  Bitte beachten Sie auch die Nutzungsbedingungen von Google Analytics.
                </p>
              </div>
            </section>

            <section className="pt-12 mt-12 border-t border-border">
              <div className="flex items-center justify-center gap-3 text-sm text-muted-foreground/60">
                <span>Konzept, Design und technische Umsetzung von</span>
                <a 
                  href="https://www.eto-personalmarketing.de" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 hover:opacity-80 transition-opacity"
                >
                  <img src={etoLogo} alt="ETO Personalmarketing" className="h-6 opacity-60" />
                </a>
              </div>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Impressum;
